"use client";

import { truncateAddress } from "@aptos-labs/wallet-adapter-react";
import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { flex } from "styled-system/patterns";

import { useUserSubaccountsQuery } from "@/contexts/queries/user-subaccounts";
import { useViewAs } from "@/contexts/view-as-context";
import { useDecibelWallet } from "@/hooks/use-decibel-wallet";

import { Banner } from "./banner";

export function ViewAsBanner() {
  const t = useTranslations("viewAsUser");
  const tColumns = useTranslations("accounts.accountColumns");
  const {
    isViewAsActive,
    viewAsAddress,
    viewAsSubaccountAddress,
    switchViewAsSubaccount,
    exitViewAs,
  } = useViewAs();

  const { accountAddress } = useDecibelWallet();
  const { data: rawSubaccounts = [] } = useUserSubaccountsQuery({
    ownerAddr: isViewAsActive ? accountAddress : undefined,
  });
  const allSubaccounts = rawSubaccounts.map((sub) => ({
    ...sub,
    label:
      sub.custom_label ??
      (sub.is_primary
        ? tColumns("primary")
        : tColumns("subaccountLabel", { label: sub.subaccount_address.slice(0, 6) })),
  }));

  if (!isViewAsActive || !viewAsAddress) return null;

  return (
    <Banner variant="warning" onDismiss={exitViewAs}>
      <div className={flex({ gap: "12", alignItems: "center", flexWrap: "wrap" })}>
        <span>{t("viewingAs", { address: truncateAddress(viewAsAddress) ?? "" })}</span>
        {allSubaccounts.length > 1 && (
          <select
            value={viewAsSubaccountAddress ?? ""}
            onChange={(e) => switchViewAsSubaccount(e.target.value)}
            className={css({
              bg: "transparent",
              border: "1px solid",
              borderColor: "banner.text",
              borderRadius: "200",
              px: "8",
              py: "2",
              textStyle: "highlight.sm",
              color: "banner.text",
              cursor: "pointer",
              maxW: "[300px]",
              truncate: true,
              _focus: {
                outline: "none",
              },
              _keyboardMode: {
                _focusVisible: {
                  outlineColor: "border.focus",
                  outlineOffset: "2",
                },
              },
            })}
          >
            {allSubaccounts.map((sub) => (
              <option key={sub.subaccount_address} value={sub.subaccount_address}>
                {sub.label}
              </option>
            ))}
          </select>
        )}
      </div>
    </Banner>
  );
}
